import { render, staticRenderFns } from "./VerCategoria.vue?vue&type=template&id=1de073e0&"
import script from "./VerCategoria.vue?vue&type=script&lang=js&"
export * from "./VerCategoria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports